import { TaskGroup } from 'models/task-groups.model';

export const CHARACTER_LIMIT = 100;

export const getErrorMessage = (
  oldValue: string,
  newValue: string,
  taskGroups: TaskGroup[],
) => {
  if (!newValue.length) {
    return 'Name is mandatory field';
  }

  if (oldValue === newValue) {
    return '';
  }

  if (
    taskGroups.find(
      (group) =>
        group.name.toLocaleLowerCase() === newValue.toLocaleLowerCase(),
    ) &&
    newValue.toLocaleLowerCase() !== oldValue.toLocaleLowerCase()
  ) {
    return 'This group already exists, please add a unique name';
  }

  if (newValue.length > CHARACTER_LIMIT) {
    return `Name must be less than ${CHARACTER_LIMIT} characters long. You are ${
      newValue.length - CHARACTER_LIMIT
    } characters over`;
  }

  return '';
};

export const getQuestionErrorMessage = (value: string) => {
  if (value.length > CHARACTER_LIMIT) {
    return `Question must be less than ${CHARACTER_LIMIT} characters long. You are ${
      value.length - CHARACTER_LIMIT
    } characters over`;
  }

  return '';
};
